import { formatDateTimeString, formatTimestamp } from "@helpers/utils";

import type { FieldRenderer } from "../types";

const renderer: FieldRenderer = (fieldValue: unknown) => {
  return {
    formattedText: formatTimestamp(fieldValue as string),
    tooltipText: formatDateTimeString(fieldValue as string),
  };
};

export default renderer;
